module.exports = "/static/assets/0d04e32d3d4c908d021182b7872488a8.gif";